import { isCcpaEligible } from 'client/utils/header-bidding/is-ccpa-eligible';

export function getPbjsEnabled(state) {
  const prebidReactAds = Boolean(state?.featureFlags?.prebidReactAds);
  if (!prebidReactAds) {
    return false;
  }

  const privacy = state?.visitor?.privacy;
  if (privacy?.doNotSell) {
    return false;
  }

  return isCcpaEligible(privacy?.uspString);
}
